import set from 'lodash/fp/set'
import { ValidationErrors } from 'middlewares/errorHandler/utils'

/**
 * Convert validation errors to redux-form errors.
 */
export function formatApiValidationErrors(validationErrors: ValidationErrors) {
  return validationErrors.reduce((result, validationError) => {
    result = set(validationError.FieldName, `global.${validationError.ErrorType}`, result)

    return result
  }, {})
}
